import { getAccessTokenFromCookie } from "../util/authentication";
import {
  TAED_SERVICE_API_ADD_TEMP_ASSIGNMENT_EVENT,
  TAED_SERVICE_API_GET_LATEST_EVENTS_BY_EID,
  TAED_SERVICE_API_GET_TAED_SNAPSHOTS_BY_STATION_AND_DATE,
  TAED_SERVICE_API_GET_TAED_SNAPSHOT_BY_REFERENCE_NUMBER,
  TAED_FILTER_DATE_TYPES,
  TAED_SERVICE_API_GET_LATEST_EVENTS_BY_REFERENCE_NUMBER,
  TAED_SERVICE_API_HAS_OVERLAPPING_TEMP_ASSIGNMENTS,
  TAED_SERVICE_API_GET_LATEST_EVENT_BY_REFERENCE_NUMBER,
} from "../util/constants";
import { getIsoDateFormat } from "../util/dateTimeFormatter";
import {
  INVALID_REFERENCE_NUMBER_ERROR_MESSAGE,
  TEMP_ASSIGNMENT_NOT_AUTHORIZED_ERROR_MESSAGE,
} from "../util/messageConstants";

export const fetchLatestTAEDEventsByEid = async (eid, eventTypes) => {
  const apiEndpoint =
    process.env.REACT_APP_TAED_API +
    TAED_SERVICE_API_GET_LATEST_EVENTS_BY_EID +
    "/" +
    eid +
    "?eventTypes=" +
    eventTypes.join(",");

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const addTempAssignmentEvent = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_TAED_API + TAED_SERVICE_API_ADD_TEMP_ASSIGNMENT_EVENT;

  const response = await fetch(apiEndpoint, {
    method: "POST",

    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const editTempAssignmentEvent = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_TAED_API + TAED_SERVICE_API_ADD_TEMP_ASSIGNMENT_EVENT;

  const response = await fetch(apiEndpoint, {
    method: "PUT",

    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};
export const cancelTempAssignmentEvent = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_TAED_API + TAED_SERVICE_API_ADD_TEMP_ASSIGNMENT_EVENT;

  const response = await fetch(apiEndpoint, {
    method: "DELETE",

    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const fetchTAEDSnapshotsByStationAndDate = async (
  station,
  dateType,
  startDate,
  endDate,
  incomingOutgoingFilters
) => {
  switch (dateType) {
    case TAED_FILTER_DATE_TYPES.ACTIVE_DATE:
    case TAED_FILTER_DATE_TYPES.START_DATE:
    case TAED_FILTER_DATE_TYPES.END_DATE:
      startDate = getIsoDateFormat(startDate);
      endDate = getIsoDateFormat(endDate);
      break;
    case TAED_FILTER_DATE_TYPES.LAST_UPDATED_DATE:
      startDate = startDate.toMillis();
      endDate = endDate.toMillis();
      break;
    default:
      console.error("Unrecognized dateType: ", dateType);
  }
  const apiEndpoint =
    process.env.REACT_APP_TAED_API +
    TAED_SERVICE_API_GET_TAED_SNAPSHOTS_BY_STATION_AND_DATE +
    "/" +
    station +
    "/" +
    dateType +
    "/" +
    startDate +
    "/" +
    endDate +
    "?incomingOutgoingFilters=" +
    incomingOutgoingFilters.join(",");

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchTAEDSnapshotByReferenceNumber = async (referenceNumber, isAdmin, station) => {
  const apiEndpoint =
    process.env.REACT_APP_TAED_API +
    TAED_SERVICE_API_GET_TAED_SNAPSHOT_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber +
    "/" +
    isAdmin +
    "/" +
    station;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (response.status === 200) {
    return await response.json();
  } else if (response.status === 403) {
    return { message: TEMP_ASSIGNMENT_NOT_AUTHORIZED_ERROR_MESSAGE };
  } else if (response.status === 404) {
    return { message: INVALID_REFERENCE_NUMBER_ERROR_MESSAGE };
  } else {
    throw Error(`GET ${apiEndpoint} API Call failed with unknown error.`);
  }
};
export const getTAEDEventsByReferenceNumber = async (referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_TAED_API + TAED_SERVICE_API_GET_LATEST_EVENTS_BY_REFERENCE_NUMBER + "/" + referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (response.status === 200) {
    return await response.json();
  } else if (response.status === 404) {
    return { message: INVALID_REFERENCE_NUMBER_ERROR_MESSAGE };
  } else {
    throw Error(`GET ${apiEndpoint} API Call failed with unknown error.`);
  }
};

export const fetchLatestTAEDEventByReferenceNumber = async (referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_TAED_API + TAED_SERVICE_API_GET_LATEST_EVENT_BY_REFERENCE_NUMBER + "/" + referenceNumber;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (response.status === 200) {
    return await response.json();
  } else if (response.status === 404) {
    return { message: INVALID_REFERENCE_NUMBER_ERROR_MESSAGE };
  } else {
    throw Error(`GET ${apiEndpoint} API Call failed with unknown error.`);
  }
};

export const fetchOverlappingTAEDValidation = async (tempAssignment) => {
  const apiEndpoint = process.env.REACT_APP_TAED_API + TAED_SERVICE_API_HAS_OVERLAPPING_TEMP_ASSIGNMENTS;
  const payload = { tempAssignment: tempAssignment };

  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: JSON.stringify(payload),
  });

  console.log("Response", response);
  if (response.status === 200) {
    return "";
  } else if (response.status === 400) {
    const responseJson = await response.json();
    console.log("responseJson.body.validationError", responseJson.validationError);
    return responseJson.validationError;
  } else {
    throw Error(`POST ${apiEndpoint} API Call failed with unknown error.`);
  }
};
